// extracted by mini-css-extract-plugin
export default {"optionsContainer":"organization-user-details-main-tab__options-container__RB1RC"};